/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_CheckingInputs */

const en_us2_profile_update_checking = /** @type {(inputs: Profile_Update_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking…`)
};

const pt_br2_profile_update_checking = /** @type {(inputs: Profile_Update_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procurando…`)
};

const es_419_profile_update_checking = /** @type {(inputs: Profile_Update_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando…`)
};

const pt_pt2_profile_update_checking = /** @type {(inputs: Profile_Update_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A procurar…`)
};

const fr_fr2_profile_update_checking = /** @type {(inputs: Profile_Update_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche…`)
};

const de_de2_profile_update_checking = /** @type {(inputs: Profile_Update_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesucht…`)
};

const it_it2_profile_update_checking = /** @type {(inputs: Profile_Update_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerca…`)
};

/**
* | output |
* | --- |
* | "Checking…" |
*
* @param {Profile_Update_CheckingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_checking = /** @type {((inputs?: Profile_Update_CheckingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_CheckingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_checking(inputs)
	if (locale === "es-419") return es_419_profile_update_checking(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_checking(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_checking(inputs)
	if (locale === "de-DE") return de_de2_profile_update_checking(inputs)
	if (locale === "it-IT") return it_it2_profile_update_checking(inputs)
	return en_us2_profile_update_checking(inputs)
});
export { profile_update_checking as "profile.update_checking" }